'use client';

import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, useEffect, useState } from 'react';
import AvatarSelectorModal from '../modals/AvatarSelectorModal';
import Image from 'next/image';
import SplashScreen from '@/components/screens/SplashScreen';
import { closingBehavior } from '@tma.js/sdk-react';
interface Props {
  needsOnboarding: boolean;
}
export default function OnboardingWrapper(t0) {
  const $ = _c(7);
  const {
    needsOnboarding,
    children
  } = t0;
  const [show, setShow] = useState("splash");
  let t1;
  let t2;
  if ($[0] !== needsOnboarding) {
    t1 = () => {
      if (needsOnboarding !== closingBehavior.isConfirmationEnabled()) {
        if (needsOnboarding) {
          closingBehavior.enableConfirmation();
        } else {
          closingBehavior.disableConfirmation();
        }
      }
    };
    t2 = [needsOnboarding];
    $[0] = needsOnboarding;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (needsOnboarding && show) {
    if (show === "splash") {
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <SplashScreen isBrowser={false}><div className="flex flex-col items-center justify-center text-center p-8"><div className="mb-8"><Image src="/bird.png" alt="RBF" width={180} height={180} priority={true} /><h1 className="text-5xl mt-6">RBF</h1></div><button onClick={() => {
              setShow("selector");
            }} className="rounded-full bg-linear-to-r from-primary to-secondary px-10 py-5 text-2xl font-semibold transition-all hover:scale-105 active:scale-95">Confirm I'm a Bird</button></div></SplashScreen>;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      return t3;
    } else {
      let t3;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <AvatarSelectorModal onSelect={() => setShow(null)} />;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      return t3;
    }
  }
  let t3;
  if ($[5] !== children) {
    t3 = <>{children}</>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}